import React, { useContext, forwardRef } from 'react'
import {
    Container,
    FieldDiv,
    FieldText
} from './style'
import { movementHeadersText } from '../../../../../pages/ClientPanel/Stock/MovementsTable/utils'
import SectionContext from '../../../../../contexts/SectionContext'
import { completeHeaders } from '../../../../../pages/ClientPanel/Stock/StockTable/utils'

interface FieldsDropdownProps {
    text: string;
    onClick: (field: string) => void;
}

const FieldsDropdown = React.forwardRef<HTMLDivElement, FieldsDropdownProps>((props, forwardedRef) => {
    const { stockSection } = useContext(SectionContext);

    let allHeaders: string[] = [];

    if (stockSection === 'stock') {
        allHeaders = [...completeHeaders];
    } else if (stockSection === 'movement') {
        allHeaders = [...movementHeadersText];
    }

    let filteredHeaders = [...allHeaders];


    if (props.text !== "" && !allHeaders.includes(props.text)) {
        filteredHeaders = filteredHeaders.filter((str: string) =>
            str.toLowerCase().includes(props.text.toLowerCase())
        );
    }

    return (
        <Container ref={forwardedRef}>
            {filteredHeaders.map((field: string) =>
                <FieldDiv key={field} onClick={() => props.onClick(field)}>
                    <FieldText>{field}</FieldText>
                </FieldDiv>
            )}
        </Container>
    );
});

FieldsDropdown.displayName = 'FieldsDropdown';

export default FieldsDropdown;